import { render } from "./AppSprinklrAuthorize.vue?vue&type=template&id=0e4b9a7f&ts=true"
import script from "./AppSprinklrAuthorize.vue?vue&type=script&lang=ts"
export * from "./AppSprinklrAuthorize.vue?vue&type=script&lang=ts"

import exportComponent from "/home/appstore/appstore/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__